"use client";

import { motion } from "framer-motion";

export const AnimatedFading = ({ id, children }: { id: string, children: React.ReactNode }) => {
    return (
        <motion.div
            key={ id }
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
        >
            {children}
        </motion.div>
    );
};